function EventHeader({ event }) {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-2">
        {event.title}
      </h2>

      <p className="text-gray-600 mb-6">
        {new Date(event.event_date).toLocaleDateString()}
        <br />
        {event.place}
      </p>
    </>
  );
}

export default EventHeader;
